import { Link } from "@onclicks/sharedmobilei18n/routing";

export const LinkMenuElement = ({
  textLink,
  linkHref,
  isOpen,
  setIsOpen,
  action,
  className,
}: {
  textLink: string;
  linkHref?: string;
  isOpen: boolean;
  setIsOpen: any;
  action?: any;
  className?: string;
}) => {
  return (
    <div
      className={`px-6 py-2 hover:bg-white/10 transition-colors cursor-pointer text-lg font-normal ${className}`}
      onClick={() => setIsOpen(!isOpen)}
    >
      <span onClick={action ? () => action() : () => {}}>
        {linkHref ? (
          <Link href={linkHref}>
            <p>{textLink}</p>
          </Link>
        ) : (
          <p>{textLink}</p>
        )}
      </span>
    </div>
  );
};
